import { render, staticRenderFns } from "./ExpandButton.vue?vue&type=template&id=ca6a0d7e&lang=pug&"
import script from "./ExpandButton.vue?vue&type=script&lang=ts&"
export * from "./ExpandButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports